import React, { Component } from "react";
import slide01 from "../../assets/img/slide01.jpg";
import slide02 from "../../assets/img/slide02.jpg";
import slide03 from "../../assets/img/slide03.jpg";

class Slide extends Component {

    render() {
        return(
            <React.Fragment>
                	{/* <!-- Images from Unsplash --> */}
                <script type="text/javascript" src="../../assets/js/jquery.min.js"></script>
                <script type="text/javascript" src="../../assets/js/jquery-3.3.1.min.js"></script>
                <script type="text/javascript" src="../../assets/js/bootstrap.min.js"></script>
                <script type="text/javascript" src="../../assets/js/owl.carousel.js"></script>
                <script type="text/javascript" src="../../assets/js/owl.carousel.min.js"></script>
                <script type="text/javascript" src="../../assets/js/calls.js"></script>
                <link rel="stylesheet" href="../../assets/css/owl.carousel.min.css"></link>
                <div class="slider-container">
                    
                    <div class="slide" style={{ backgroundImage: `url(${slide01})` }}>
                        <div class="slider-text">
                            <div class="container">
                                <div class="col-12 col-md-8 col-lg-7">
                                    <h2>Na clínica ou hospital</h2>
                                    <h1>Eleve o nível da experiência de atendimento do seu cliente e melhore seus processos</h1>

                                    <br></br>

                                    <div class="row m-auto">					
                                        <a href="#quem-somos" class="btn-itm bounce"><span class="ico-seta"></span> Conheça Mais</a>
                                    </div>
                                    <span id="teste"></span>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div class="slide" style={{ backgroundImage: `url(${slide02})` }}>
                        <div class="slider-text">
                            <div class="container">
                                <div class="col-12 col-md-8 col-lg-7">
                                    <h2>No varejo</h2>
                                    <h1>A prevenção de perda e o monitoramento da temperatura em suas mãos.</h1>

                                    <br></br>

                                    <div class="row m-auto">					
                                        <a href="#quem-somos" class="btn-itm bounce"><span class="ico-seta"></span> Conheça Mais</a>
                                    </div>
                                    <span id="teste"></span>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div class="slide" style={{ backgroundImage: `url(${slide03})` }}>
                        <div class="slider-text">
                            <div class="container">
                                <div class="col-12 col-md-8 col-lg-7">
                                    <h2>Na hotelaria</h2>
                                    <h1>Controle dos enxovais e gestão ativa da equipe de limpeza</h1>
                                    
                                    <br></br>
                                    
                                    <div class="row m-auto">					
                                        <a href="#quem-somos" class="btn-itm bounce"><span class="ico-seta"></span> Conheça Mais</a>
                                    </div>
                                    <span id="teste"></span>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div class="controls-container">
                        <div class="container">
                            <div class="control"></div>
                            <div class="control"></div>
                            <div class="control"></div>
                        </div>
                    </div>
                </div>


                <span id="quem-somos"><br></br><br></br></span>
            </React.Fragment>
        );
    }
}

export default Slide;